export default __webpack_public_path__ + "static/media/bg11.8f25849d.jpg";